import PropTypes from "prop-types";
import React from "react";

const Switch = ({
  currentSwitchState,
  handleChange,
  id,
  disabled,
  ariaLabel,
}) => (
  <button
    className="switch__container"
    id={id}
    onClick={handleChange}
    type="button"
    disabled={disabled}
    role={ariaLabel ? "switch" : undefined}
    aria-checked={ariaLabel ? currentSwitchState : undefined}
    aria-label={ariaLabel}
    data-testid="vt-switch"
  >
    <span
      className={`switch__slider${currentSwitchState ? " active" : ""}${
        disabled ? " disabled" : ""
      }`}
    >
      &nbsp;
    </span>
  </button>
);

export default Switch;

Switch.propTypes = {
  currentSwitchState: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};
